import App from 'app/app.js';
import 'app/service/EventService.js';

function JobLoadedAction(EventService) {
  this.eventName = 'jobLoaded';

  this.dispatch = function (firstName) {
    EventService.dispatch(this.eventName, { firstName: firstName });
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('JobLoadedAction', ['EventService', JobLoadedAction]);
